import React from "react";
import "./ErrorPage.css";

const STATUS_DEFAULTS = {
  404: { title: "Not Found", message: "The page you are looking for does not exist." },
  403: { title: "Forbidden", message: "You do not have permission to access this page." },
  401: { title: "Unauthorized", message: "You need to log in to access this page." },
  500: { title: "Server Error", message: "Something went wrong on our end. Please try again later." },
  503: { title: "Service Unavailable", message: "The service is temporarily unavailable. Please try again later." },
};

export default function ErrorPage({ statusCode = 404, title, message, buttonText, onBack }) {
  const defaults = STATUS_DEFAULTS[statusCode] || { title: "Error", message: "An unexpected error occurred." };

  return (
    <div className="page">
      <div className="ErrorPage__container">
        <div className="ErrorPage__status-code">{statusCode}</div>
        <h2 className="ErrorPage__title">{title || defaults.title}</h2>
        <p className="ErrorPage__message">{message || defaults.message}</p>
        {onBack && (
          <button className="k-btn k-btn-outline-primary" onClick={onBack}>
            {buttonText || "Go Back"}
          </button>
        )}
      </div>
    </div>
  );
}
